import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = {
  class: "navbar navbar-vertical navbar-light fixed-start navbar-expand-md d-md-none",
  id: "sidebar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "navbar-user d-md-none"
}
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "sidebarIcon"
}
const _hoisted_6 = { class: "dropdown-item text-muted" }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand text-start",
        to: _ctx.$paths.validator
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "navbar-brand-img mx-auto",
            alt: "..."
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["to"]),
      (_ctx.session)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                href: "#",
                id: "sidebarIcon",
                class: "dropdown-toggle",
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, [
                _createElementVNode("div", { class: "avatar avatar-sm" }, [
                  _createElementVNode("i", {
                    class: "fa-solid fa-user-circle text-muted",
                    style: {"font-size":"40px"}
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.session?.name), 1),
                _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "dropdown-item text-danger cursor-pointer"
                }, "Sair")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              tag: "button",
              to: _ctx.$paths.login,
              class: "btn btn-outline-primary"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Entrar", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])),
      _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "navbar-collapse collapse",
        id: "sidebarCollapse",
        style: {}
      }, [
        _createElementVNode("ul", { class: "navbar-nav" })
      ], -1))
    ])
  ]))
}